import { createPortal } from 'react-dom';
import { FormatDecimal1, FormatInt } from '../utils/numberUtils';

/**
 * Barra flutuante de estatísticas da seleção de células (estilo Excel).
 * Renderizada via portal no <body> com position:fixed — imune a `overflow`
 * e a `transform` de ancestrais (Splitter/Workspace). pointer-events:none pra
 * nunca bloquear cliques na tabela embaixo.
 *
 * Números mistos (seleção pode cruzar colunas de unidades diferentes): mostra
 * valores CRUS, sem R$/% — mesma semântica do Excel (count/sum/avg do que tá
 * selecionado, sem inferir unidade).
 */
function fmtNum(n) {
    // Inteiro exato → sem casas; senão 1 casa decimal.
    return Number.isInteger(n) ? FormatInt(n) : FormatDecimal1(n);
}

export function SelectionStatsBar({ visible, pos, stats, T }) {
    if (!visible || !pos || !stats) return null;
    const items = [
        ['Cont.', String(stats.count)],
        ['Soma', fmtNum(stats.sum)],
        ['Média', FormatDecimal1(stats.avg)],
        ['Mín', fmtNum(stats.min)],
        ['Máx', fmtNum(stats.max)],
    ];
    return createPortal(
        <div
            data-sel-bar="1"
            style={{
                position: 'fixed',
                left: pos.left,
                top: pos.top,
                transform: 'translate(-50%, calc(-100% - 8px))',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'stretch',
                background: T.ink,
                color: T.bg,
                borderRadius: 6,
                padding: '4px 2px',
                boxShadow: '0 6px 20px rgba(0,0,0,0.28)',
                fontFamily: T.mono,
                whiteSpace: 'nowrap',
                pointerEvents: 'none',
                userSelect: 'none',
            }}
        >
            {items.map(([label, val], i) => (
                <div
                    key={label}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '0 9px',
                        borderRight: i < items.length - 1 ? `1px solid ${T.muted}` : 'none',
                    }}
                >
                    <span style={{ fontSize: 9, opacity: 0.6, textTransform: 'uppercase', letterSpacing: 0.4 }}>
                        {label}
                    </span>
                    <span style={{ fontSize: 12, fontWeight: 600 }}>{val}</span>
                </div>
            ))}
        </div>,
        document.body,
    );
}
